module.exports = __webpack_public_path__ + "static/media/star.5889d7c1.svg";